import React from 'react'
import { connect } from 'react-redux'
import { addActionToButton } from "../actions"
import NavBarItem from "../components/NavBarItem"
import constants from "./Constants"
import { tooltips } from "../constants"
import commands from '../json/commands.json'
import Immutable from 'immutable'
import { toggleModal } from '../actions'
import { Modals } from "../constants"

// SYSEX CONSTRUCTION //
// 0: 0xF0 Start Bit
// 1: 0x1E DataLooper Identifier
// 2: Action (config start/stop/command
// 3: Button Number
// 4: Execute On
// 5-9 : Data Bit

class Upload extends React.Component {
    constructor(props, dispatch) {
        super(props)

        this.state = { midiConnected: false, listenerAdded: false }


    }
    componentDidUpdate() {
        if (this.props.connection.get('input') && !this.state.midiConnected) {
            var input  = this.props.connection.get('input')
            console.log("setting up midi input listener",input, this.state)
            if(!this.state.listenerAdded)
                input.addEventListener("midimessage", this.onMIDIMessage);
                this.setState({
                    listenerAdded: true
                });
            this.setState({
                midiConnected: true
            });
        } else if (!this.props.connection.get('input') && this.state.midiConnected) {
            console.log("removing midi input listener", this.props.connection, this.state)

            this.setState({
                midiConnected: false
            });
        }
    }
    onMIDIMessage = (event) => {
        var command_type = event.data[2]
        console.log("midi message received", event.data, command_type)
        if (event.data[0] == 0xF0 && event.data[1] == 0x1E && command_type == 13 && event.data[3] <= this.props.actions.size){
            console.log("received midi message to sync preset #", parseInt(event.data[3]))
            this.syncDataLooper(parseInt(event.data[3]))
        }
    }
    syncDataLooper = (preset) => {

        console.log("Sync DataLooper Pressed")
        console.log("syncing preset #", preset, "of : ", this.props.actions.size)
        if (this.props.actions.size > 0 && preset == 0) {
                //sync global
                console.log('syncing global', this.props.settings)
                var settings = [0xF0, 0x1E, 10]
                var ordered = this.props.settings.toOrderedMap().sort()
                ordered.forEach(
                    function (settingValue, settingKey) {
                        console.log("setting value: ", settingValue.get("value"), settingKey)
                        settings.push(settingValue.get("value"));
                    }, this
                )
                settings = settings.concat(this.props.actions.size, [0xF7])
                this.props.connection.get('output').send(settings);
            } 
            else {

                var presetColor = this.props.presetSettings.present.getIn([String(preset),"color"]) !== undefined ? hexStringToByte(this.props.presetSettings.present.getIn([String(preset),"color"]).substring(1)) : hexStringToByte("FFFFFF")
                var presetName = this.props.presetSettings.present.getIn([String(preset),"name"]) !== undefined ? this.props.presetSettings.present.getIn([String(preset),"name"]) : ""
                var presetData = this.props.actions.get(String(preset));
                console.log("preset data", this.props.presetSettings.present, presetColor, presetName)
                if (presetData !== undefined) {
                    var presetCommands = [];
                    for (var x = 0; x < constants.num_buttons; x++) {
                        var button = presetData.get(x.toString());
                        presetCommands[x] = loadButtonCommands(button, x, this.props.settings);
                    }
            
                    console.log("Preset Commands:", presetCommands);
            
                    var presetMsg = [0xF0, 0x1E, 7, preset - 1],
                        checkSum = presetCommands.flat().reduce(function (a, b) {
                            return a + b;
                        });
            
                    console.log("Intermediate Checksum Value:", checkSum);
            
                    checkSum = 127 - (checkSum % 127);
            
                    console.log("Final Checksum Value:", checkSum);
                    presetName = Array.from(presetName, char => char.charCodeAt(0)); 
                    var presetNameBytes = Array(5).fill(0)
                    for (var x = 0; x < presetName.length; x++) {
                        presetNameBytes[x] = presetName[x]
                    } 
                    presetMsg = presetMsg.concat(presetCommands.flat(), checkSum, presetColor, presetNameBytes, [0xF7])
                       
                    if (parseInt(preset) == this.props.actions.size) {
                        console.log("sending end of config message")
                        presetMsg[2] = 8
                    }
                    console.log("Preset #", preset, "Commands", presetData, "Sysex", presetMsg, "Checksum: ", checkSum);
                    this.props.connection.get('output').send(presetMsg);
                }
            }
        }
    


    render() {
        return <NavBarItem tooltip={tooltips.Upload}
            onClick={
                () => this.syncDataLooper(0)
            }
            icon={this.props.icon}
            name={this.props.name}
        />;

    }

}

function hexStringToByte(str) {
    if (!str) {
        return [];
    }

    var a = [];
    for (var i = 0, len = str.length; i < len; i += 2) {
        var val = parseInt(str.substr(i, 2), 16);
        a.push(val >> 1)

    }

    return a;
}

function mapDispatchToProps(dispatch) {

    return {

        addActionToButton: (preset, buttonID, actionName, action) => dispatch(addActionToButton(preset, buttonID, actionName, action))
    }
}

function mapStateToProps(state) {
    return {
        actions: state.buttonActions.present,
        connection: state.connection,
        settings: state.settings,
        presetSettings: state.presetSettings
    }
}

function sendSysex(connection, sysex) {
    //console.log("sending: ", sysex)
    connection.get('output').send(sysex);
}

function loadButtonCommands(button, buttonNum, settings) {
    var actionNum = 0, commands = [];
    //console.log("button num:", buttonNum, button)

    // execute on, action type, action subtype, data slots
    while (actionNum < constants.num_actions) {
        commands[actionNum] = [...constants.defaultSysex];
        var actionValue = button === undefined ? undefined : button.toIndexedSeq().get(actionNum)
        if (actionValue !== undefined) {
            commands[actionNum][0] = actionValue.get('executeOn') ? parseInt(actionValue.get('executeOn')) : 0;
            actionValue.get('data').mapKeys(
                (key, value) => {
                    if (key.includes('data')) {
                        var index = parseInt(key.split('-')[1])
                        commands[actionNum][index] = parseInt(value);
                    }
                }
            );
            actionValue.get("options").forEach(
                function (optionValue, optionKey) {
                    if (optionKey === "Channel" && optionValue.get('value') == 0) {
                        commands[actionNum][optionValue.get('data-slot')] = parseInt(settings.get("Global Channel").get("value"));

                    } else if (!optionValue.get('isHidden')) {
                        commands[actionNum][optionValue.get('data-slot')] = parseInt(optionValue.get('value'));
                    }
                }
            )
        }
        actionNum++;
    }


    console.log("finishing button command", buttonNum, commands, commands.flat())
    return commands.flat()
}

export default connect(
    mapStateToProps, mapDispatchToProps)(Upload)